/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import logger from"@accedo/xdk-log";const{warn:warn}=logger({logTag:"[core/base/core]"});let WINDOW_DEFINED="undefined"!=typeof window,guid=1,core={version:"${version}",buildNumber:"${timestamp}-${gitCommit}",root:function(e){return e?window:(warn("window object cannot be found!"),{})}(WINDOW_DEFINED),userAgent:"undefined"!=typeof navigator?navigator.userAgent:(warn("User agent string cannot be found!"),""),isBrowser:()=>WINDOW_DEFINED,getGuid:()=>guid++};export default core;